// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nasu","fullView":"styles_fullView__3vUA_"};